import { Box, BoxProps } from '@chakra-ui/layout';

const SvgFwcLogo = (props: BoxProps) => (
  <Box as="svg" viewBox="0 0 539.7 252" {...props}>
    <path
      fill="#004E77"
      d="M1 251V47.4h169.2v154.9c-1.5 1.3-8.2 7-20.3 13.9-12.7 7.2-34.1 17.3-63.9 24C45 249.6 16.3 251 2.7 251H1"
    />
    <path
      fill="#FFF"
      d="M169.2 48.4v153.5c-4.4 3.8-31.3 25.7-83.4 37.5C44.9 248.6 16.2 250 2.7 250H2V48.4h167.2m2-2H0V252h2.7c13 0 42.1-1.3 83.5-10.7 58-13.1 84.9-38.5 84.9-38.5V46.4z"
    />
    <defs>
      <path
        id="fwc--logo_svg__a"
        d="M122.4 101.7c-5.1 9.9-10.6 19.6-16.4 29l42.4-19.1s2.9-3.3 5-9.9h-31z"
      />
    </defs>
    <clipPath id="fwc--logo_svg__b">
      <use xlinkHref="#fwc--logo_svg__a" overflow="visible" />
    </clipPath>
    <linearGradient
      id="fwc--logo_svg__c"
      gradientUnits="userSpaceOnUse"
      y1={252.092}
      x2={1}
      y2={252.092}
      gradientTransform="scale(-44.4308 44.4308) rotate(37.304 368.296 122.402)"
    >
      <stop offset={0} stopColor="#fff" />
      <stop offset={1} stopColor="#bbbdbf" />
    </linearGradient>
    <path
      clipPath="url(#fwc--logo_svg__b)"
      fill="url(#fwc--logo_svg__c)"
      d="M167.4 120.1l-44 33.5L92 112.4l44-33.5z"
    />
    <defs>
      <path
        id="fwc--logo_svg__d"
        d="M56.9 161.2l24.3-4.2h8.2c7.5-10.8 16.6-26.3 16.6-26.3l-37.3-8.1c-3.5 13.2-7.5 26.5-11.8 38.6"
      />
    </defs>
    <clipPath id="fwc--logo_svg__e">
      <use xlinkHref="#fwc--logo_svg__d" overflow="visible" />
    </clipPath>
    <linearGradient
      id="fwc--logo_svg__f"
      gradientUnits="userSpaceOnUse"
      y1={252.042}
      x2={1}
      y2={252.042}
      gradientTransform="scale(25.1775 -25.1775) rotate(74.745 170.486 125.08)"
    >
      <stop offset={0} stopColor="#fff" />
      <stop offset={1} stopColor="#bbbdbf" />
    </linearGradient>
    <path
      clipPath="url(#fwc--logo_svg__e)"
      fill="url(#fwc--logo_svg__f)"
      d="M47.1 158.6l13.2-48.4 55.5 15.1-13.2 48.4z"
    />
    <defs>
      <path
        id="fwc--logo_svg__g"
        d="M23.9 228.1c-1.6 2-.8 4 2.3 1.5 2.2-1.8 27.7-24.5 54.7-60.6L55 166.4s-17.7 41.4-31.1 61.7"
      />
    </defs>
    <clipPath id="fwc--logo_svg__h">
      <use xlinkHref="#fwc--logo_svg__g" overflow="visible" />
    </clipPath>
    <linearGradient
      id="fwc--logo_svg__i"
      gradientUnits="userSpaceOnUse"
      y1={251.969}
      x2={1}
      y2={251.969}
      gradientTransform="scale(86.529 -86.529) rotate(58.173 229.051 124.996)"
    >
      <stop offset={0} stopColor="#fff" />
      <stop offset={0.082} stopColor="#fff" />
      <stop offset={0.304} stopColor="#f4f4f5" />
      <stop offset={0.693} stopColor="#d7d8d9" />
      <stop offset={1} stopColor="#bbbdbf" />
    </linearGradient>
    <path
      clipPath="url(#fwc--logo_svg__h)"
      fill="url(#fwc--logo_svg__i)"
      d="M-7.1 213.8l45.7-73.7 71.7 44.5-45.7 73.7z"
    />
    <defs>
      <path
        id="fwc--logo_svg__j"
        d="M24.9 144.7c-1.6 3.4.4 3.3 5.2-2.9 3.3-4.2 13.9-17.4 21-30.1l-10.8-9.9c.1-.1-2.6 15.2-15.4 42.9"
      />
    </defs>
    <clipPath id="fwc--logo_svg__k">
      <use xlinkHref="#fwc--logo_svg__j" overflow="visible" />
    </clipPath>
    <linearGradient
      id="fwc--logo_svg__l"
      gradientUnits="userSpaceOnUse"
      y1={251.907}
      x2={1}
      y2={251.907}
      gradientTransform="scale(33.671 -33.671) rotate(54.516 248.847 124.738)"
    >
      <stop offset={0} stopColor="#fff" />
      <stop offset={1} stopColor="#bbbdbf" />
    </linearGradient>
    <path
      clipPath="url(#fwc--logo_svg__k)"
      fill="url(#fwc--logo_svg__l)"
      d="M1.5 132.5l31.2-43.9 40.4 28.8-31.3 43.8z"
    />
    <defs>
      <path id="fwc--logo_svg__m" d="M112.9 69.6l5.1 12.7 19.5-9-3.8-6.7z" />
    </defs>
    <clipPath id="fwc--logo_svg__n">
      <use xlinkHref="#fwc--logo_svg__m" overflow="visible" />
    </clipPath>
    <linearGradient
      id="fwc--logo_svg__o"
      gradientUnits="userSpaceOnUse"
      y1={251.856}
      x2={1}
      y2={251.856}
      gradientTransform="scale(16.6425 -16.6425) rotate(35.818 400.54 134.754)"
    >
      <stop offset={0} stopColor="#fff" />
      <stop offset={1} stopColor="#bbbdbf" />
    </linearGradient>
    <path
      clipPath="url(#fwc--logo_svg__n)"
      fill="url(#fwc--logo_svg__o)"
      d="M105.5 71.9l23.6-17 15.9 22L121.4 94z"
    />
    <path fill="#FFF" d="M118 82.3l19.4-8.9h-22.9z" />
    <g>
      <defs>
        <path
          id="fwc--logo_svg__p"
          d="M40.4 101.7l65.6 29c5.8-9.4 11.3-19.1 16.4-29h-82z"
        />
      </defs>
      <clipPath id="fwc--logo_svg__q">
        <use xlinkHref="#fwc--logo_svg__p" overflow="visible" />
      </clipPath>
      <linearGradient
        id="fwc--logo_svg__r"
        gradientUnits="userSpaceOnUse"
        y1={251.904}
        x2={1}
        y2={251.904}
        gradientTransform="scale(49.4061 -49.4061) rotate(36.027 391.851 127.043)"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#bbbdbf" />
      </linearGradient>
      <path
        clipPath="url(#fwc--logo_svg__q)"
        fill="url(#fwc--logo_svg__r)"
        d="M26.6 111.8l67.5-49.1 42.1 58-67.4 49z"
      />
    </g>
    <g>
      <defs>
        <path
          id="fwc--logo_svg__s"
          d="M111.4 143H62.9c-2.5 7.9-4.7 15.2-7.8 23.2l49.5-7.7c-2.9 9.4-7.7 22.5-15 37.3-7.7 15.7 11.1-7.4 25.2-27.3C125 154.3 131 143 131 143h-19.6z"
        />
      </defs>
      <clipPath id="fwc--logo_svg__t">
        <use xlinkHref="#fwc--logo_svg__s" overflow="visible" />
      </clipPath>
      <linearGradient
        id="fwc--logo_svg__u"
        gradientUnits="userSpaceOnUse"
        y1={251.831}
        x2={1}
        y2={251.831}
        gradientTransform="scale(52.7212 -52.7212) rotate(-13.36 -1088.22 119.633)"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#bbbdbf" />
      </linearGradient>
      <path
        clipPath="url(#fwc--logo_svg__t)"
        fill="url(#fwc--logo_svg__u)"
        d="M59.1 125.9l87.3 20.8-19.5 81.9-87.2-20.7z"
      />
    </g>
    <g>
      <defs>
        <path
          id="fwc--logo_svg__v"
          d="M76.7 78.6s-2.1 7.5-6 13.5c-1.2 1.8-1.2 3 1.4.7l9.2-7.7 3.9-6.7-8.5.2z"
        />
      </defs>
      <clipPath id="fwc--logo_svg__w">
        <use xlinkHref="#fwc--logo_svg__v" overflow="visible" />
      </clipPath>
      <linearGradient
        id="fwc--logo_svg__x"
        gradientUnits="userSpaceOnUse"
        y1={251.868}
        x2={1}
        y2={251.868}
        gradientTransform="scale(17.2135 -17.2135) rotate(29.612 488.41 131.24)"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#bbbdbf" />
      </linearGradient>
      <path
        clipPath="url(#fwc--logo_svg__w)"
        fill="url(#fwc--logo_svg__x)"
        d="M62.4 82.5l19.1-10.8 11 19.3-19.1 10.9z"
      />
    </g>
    <g>
      <defs>
        <path
          id="fwc--logo_svg__y"
          d="M136.5 97.6zm-8.4-17.5c4.7 9 7.2 14.3 8.5 17.4 5.3 1.1 15.6 3.4 16.8 4-9.9-14.3-20.9-25.9-20.9-25.9-.4.2-3.1 3.1-4.4 4.5"
        />
      </defs>
      <clipPath id="fwc--logo_svg__z">
        <use xlinkHref="#fwc--logo_svg__y" overflow="visible" />
      </clipPath>
      <linearGradient
        id="fwc--logo_svg__A"
        gradientUnits="userSpaceOnUse"
        y1={252.116}
        x2={1}
        y2={252.116}
        gradientTransform="scale(26.948 -26.948) rotate(-52.993 -253.316 119.664)"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#bbbdbf" />
      </linearGradient>
      <path
        clipPath="url(#fwc--logo_svg__z)"
        fill="url(#fwc--logo_svg__A)"
        d="M144.2 63.5l21.6 28.7-28.6 21.5-21.6-28.6z"
      />
    </g>
    <g>
      <defs>
        <path
          id="fwc--logo_svg__B"
          d="M96.6 71.6c-9.1.4-15.1 9.6-11.7 18.1.6 1.5 1.4 2.8 2.4 3.9l12.7 4c7.8-1.7 12.4-10 9.4-17.8-1.9-5-6.9-8.3-12.2-8.3-.2.1-.4.1-.6.1"
        />
      </defs>
      <clipPath id="fwc--logo_svg__C">
        <use xlinkHref="#fwc--logo_svg__B" overflow="visible" />
      </clipPath>
      <linearGradient
        id="fwc--logo_svg__D"
        gradientUnits="userSpaceOnUse"
        y1={251.999}
        x2={1}
        y2={251.999}
        gradientTransform="matrix(26.3835 0 0 -26.3835 83.95 6733.258)"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#bbbdbf" />
      </linearGradient>
      <path
        clipPath="url(#fwc--logo_svg__C)"
        fill="url(#fwc--logo_svg__D)"
        d="M81.5 71.6h30.9v26H81.5z"
      />
    </g>
    <g>
      <path d="M210.5 71.9c-1.2.1-4.9.5-10.4.5h-6.2v19.2h-4.4V50.9h25.9v3.7h-21.5v14.2h16.6v3.1zm17.1-21v29.5c0 8 5.2 8.1 12 8.1s12-.2 12-8.1V50.9h4.4v29c0 5.3-.2 6.2-3.3 9.2-2.9 2.9-4.3 3.1-13.1 3.1-8.9 0-10.2-.2-13.1-3.1-3.1-3.1-3.3-4-3.3-9.2v-29h4.4zm61.9 21c-1.2.1-4.9.5-10.4.5h-7.4v12.4c0 2.8.8 3.4 3.1 3.4h20.1v2.9c-1.2.1-4.9.5-10.4.5h-11.4c-1.4 0-2.4-.5-3.9-2-1.4-1.4-1.8-2.3-1.8-3.5V50.9h27.5v3.7h-23.2v14.2h17.8v3.1zm19.1-21v33.9c0 2.8.8 3.4 3.1 3.4h18.6v2.9c-1.2.1-4.9.5-10.4.5H310c-1.4 0-2.4-.5-3.9-2-1.4-1.4-1.8-2.3-1.8-3.5V50.9h4.3zm34.4 0v33.9c0 2.8.8 3.4 3.1 3.4h18.6v2.9c-1.2.1-4.9.5-10.4.5h-9.9c-1.4 0-2.4-.5-3.9-2-1.4-1.4-1.8-2.3-1.8-3.5V50.9h4.3zm30.1 0h4.4v40.7h-4.4zm16.3 0h4c1.7 0 2.3.1 3.6 1.1 1.5 1.2 2 1.7 2.9 3.2l19.5 33.3h.6V50.9h4.2v40.7H420c-1.7 0-2.5-.4-3.7-1.3-1.1-.9-1.4-1.1-2.2-2.5L394.3 54h-.6v37.6h-4.3V50.9zm79.2 33.4c0 2.1-.1 3.3-2.2 5.5-1.9 1.9-7.9 2.5-12.5 2.5-6.1 0-10.2-.8-14.2-4.8-4.2-4.4-5.3-7.4-5.3-16s.8-12 5.1-16.3c4.4-4.4 8.2-4.8 15-4.8 3.9 0 8 .5 11.9 1.7l-.8 2.8c-2.8-.4-6.9-.9-10.4-.9C442 54 439 57.6 439 71s3 17.7 15.7 17.7c3.5 0 6-.4 9.3-.8V74.5h-8.6v-3.7h13.1v13.5zM195.7 103l3.3 29.9h1.3l5.8-29.9h15.4l6.2 29.9h1.3l2.9-29.9h12.7l-5.2 35.9c-.4 2.6-1.7 3.7-2.9 4.6-1.4 1.1-2.6 2-4.8 2h-12.1l-5.1-27.6h-.8l-3.7 21c-.4 2.6-1.7 3.7-2.9 4.6-1.4 1.1-2.6 2-4.8 2h-12l-6.8-42.5h12.2zm55.1 38.4c-4.2-4.2-4.5-8.5-4.5-17.1 0-8.6.2-12.4 4.5-16.6 4.3-4.2 7.5-5.3 15.1-5.3s10.8.4 15.1 4.7c4.2 4.2 4.5 8.2 4.5 16.8 0 8.6-.2 13.3-4.5 17.5-4.3 4.2-7.5 4.7-15.1 4.7s-10.8-.5-15.1-4.7m22.9-17.3c0-9.1-.2-11.5-7.8-11.5-7.5 0-7.8 2.9-7.8 11.5 0 9.1.2 11.8 7.8 11.8 7.5 0 7.8-3.2 7.8-11.8m45.7-14c1-2.6 1.6-3.2 4.1-5.1 2.2-1.6 3.1-2.1 5.4-2.1h9.6v42.5h-11.4V118h-.6l-7.1 17.7h-9.8l-7.1-17.7h-.6v27.4h-11.3V103H301c2.3 0 3.2.5 5.4 2.1 2.5 1.9 3.1 2.5 4.1 5.1l4.1 10.5h.8l4-10.6zm53.8 17.8c-1.2.1-4.9.5-10.4.5h-6.7v4.3c0 2.8.8 3.4 3.1 3.4h16.4v8.9c-1.2.1-4.9.5-10.4.5h-11.4c-3.6 0-4.3-.5-6.5-2.8-1.9-1.9-2.8-2.9-2.8-7.1V103h31.1v9.6h-19.5v6.5h17.1v8.8zm7.5-24.9h8.4c2.6 0 3.5 1 5.3 2.3 2.1 1.5 2.9 2.2 4.2 4.7l9.1 18.3h.6V103h11.1v42.5h-8c-2.6 0-3.5-1-5.3-2.3-2.1-1.5-2.9-2.2-4.2-4.7l-9.5-18.3h-.6v25.3h-11.1V103zm-160.3 94.7c-3.5 1.2-9.9 2.2-15.3 2.2-4.2 0-9.7-.2-14.3-4.7-4.3-4.2-5.1-8.3-5.1-17.4 0-8.6.8-12.6 5.1-16.9 4.4-4.4 9.4-4.8 16.2-4.8 3.9 0 9.2 1.1 13.1 2.4l-2 9.3c-2.8-.4-6.9-.9-10.4-.9-8 0-10.2 1.7-10.2 10.4 0 9.8 1.9 11.7 9.8 11.7 3.5 0 8.1-.5 11.4-1l1.7 9.7zm15.2-40.9v15.6h14.7v-15.6h11.6v42.6h-11.6v-16.8h-14.7v16.8H224v-42.6zm41 0h9.5c3 0 4.6.4 7 2.5 2.9 2.5 3.4 3.1 4.4 6.4l9.9 33.6h-12.2l-2.2-8.1h-14.9l-2.2 8.1h-11.6l12.3-42.5zm4 24.8h9.8l-4.1-15.6h-1.4l-4.3 15.6zm57.9-17.6c1-2.6 1.6-3.2 4.1-5.1 2.2-1.6 3.1-2.1 5.4-2.1h9.6v42.5h-11.4v-27.4h-.6l-7.1 17.7h-9.8l-7.1-17.7h-.6v27.4h-11.3v-42.5H320c2.3 0 3.2.5 5.4 2.1 2.5 1.9 3 2.5 4.1 5.1l4.1 10.5h.8l4.1-10.5zm25.1-7.2h21.1c5.5 0 7.8.4 10.7 3.4 2.3 2.3 2.9 5.7 2.9 11.5 0 6.8-.9 10.1-2.9 12-2.8 2.6-4.8 3.4-10.8 3.4h-9.3v12.2h-11.6v-42.5zm11.6 20.8h7.1c3.6 0 4.4-1.1 4.4-6 0-3.5-.7-5-3.8-5h-7.6v11zm27.6-20.8h11.6v42.5h-11.6zm21.2 38.5c-4.2-4.3-4.5-8.5-4.5-17.1s.2-12.4 4.5-16.6c4.3-4.2 7.5-5.3 15.1-5.3s10.8.4 15.1 4.7c4.3 4.2 4.5 8.2 4.5 16.8 0 8.6-.2 13.3-4.5 17.5-4.3 4.3-7.5 4.7-15.1 4.7-7.7 0-10.9-.5-15.1-4.7m22.8-17.3c0-9.1-.2-11.5-7.8-11.5-7.5 0-7.8 2.9-7.8 11.5 0 9.1.2 11.8 7.8 11.8s7.8-3.2 7.8-11.8m16.9-21.2h8.4c2.6 0 3.5 1 5.3 2.3 2.1 1.5 2.9 2.2 4.2 4.7l9.1 18.3h.6v-25.3h11.1v42.5h-8c-2.6 0-3.5-1-5.3-2.3-2.1-1.5-2.9-2.2-4.2-4.7l-9.5-18.3h-.6v25.3h-11.1v-42.5zm45.5 31.5c2.5.4 10 .9 13.5.9 4.7 0 5.6-1 5.6-2.3 0-1-.7-2.3-3.4-3.1l-8.3-2.5c-3.7-1.1-5-2.3-6.9-5-1.7-2.4-1.9-5.1-1.9-7.6 0-4.1.8-5.6 3.8-8.5 3.4-3.3 7.1-4 11-4 4.5 0 11.6.8 15.4 2.1l-2 9.6c-2.7-.5-8.9-.9-13.4-.9-2 0-3.5.3-3.5 1.9 0 1 .5 1.9 3.6 2.9l7.8 2.4c4.1 1.3 5.7 2.8 7.2 5.3 1.7 2.8 1.9 4.8 1.9 7.6 0 3.8-.5 6.5-4.7 9.6-3.9 3-7.8 3.2-12.3 3.2-4.5 0-11.7-.8-15.5-2l2.1-9.6zM22.4 29.8c-2.4.8-5.8 1.3-9.1 1.3-3.8 0-6.8-.4-9.7-3.3C.6 24.9 0 22.6 0 16.6c0-5.9.6-8.4 3.5-11.3C6.5 2.3 9.4 2 14 2c2.7 0 5.8.5 8.4 1.4l-.8 3.4c-1.9-.3-4.7-.6-7.1-.6-7.9 0-9.7 2-9.7 10.1 0 8.4 1.8 10.8 9.4 10.8 2.4 0 5.3-.3 7.5-.7l.7 3.4zm12-27.3h3.4c1.7 0 2.3.2 3.4 1.1 1.2 1 1.5 1.2 2.1 3.1l8.5 24h-5L44.6 24h-13l-2.3 6.7h-4.6l9.7-28.2zm-1.6 17.6h10.5L38.6 5.9h-1l-4.8 14.2zM55.9 2.5h3.8c1.4 0 1.8.3 2.8 1 1.2.9 1.6 1.2 2.3 2.5l11 19.4h.4V2.5h4.5v28.2h-3.8c-1.4 0-1.9-.4-2.9-1.1-1-.8-1.3-1.1-2-2.3L60.8 7.8h-.4v22.9h-4.5V2.5zm38.6 0h3.4c1.7 0 2.3.2 3.4 1.1 1.2 1 1.5 1.2 2.1 3.1l8.5 24h-5l-2.2-6.7h-13l-2.3 6.7h-4.6l9.7-28.2zm-1.6 17.6h10.5L98.7 5.9h-1l-4.8 14.2zM116 2.5h10.5c4.7 0 7.4 0 10.4 3.1 2.7 2.7 2.9 4.9 2.9 11.1 0 6.1-.1 8.1-3 11-2.9 2.9-5.7 3.1-10.4 3.1H116V2.5zm4.7 24.4h5.8c7.4 0 8.6-2 8.6-10.5 0-8.1-.7-10.1-8.6-10.1h-5.8v20.6zm32-24.4h3.4c1.7 0 2.3.2 3.4 1.1 1.2 1 1.5 1.2 2.1 3.1l8.5 24h-5l-2.2-6.7h-13l-2.3 6.7H143l9.7-28.2zm-1.6 17.6h10.5l-4.7-14.2h-1l-4.8 14.2zm24.4-15.6c0 2.2-.7 6.1-1.6 7.8h-3.3c.4-1.7 1-4.5 1-7-.9-.1-1.3-.4-1.3-1.6V0h5.2v4.5zm4.8 21.9c1.8.3 5.7.6 8.1.6 4.3 0 7.2-.3 7.2-3.5 0-1.8-.2-2.6-2.1-3.3l-8.2-2.9c-2.4-.9-2.9-1.4-4.1-2.9-1-1.3-1.4-2.8-1.4-4.2 0-2.8.7-3.7 2.4-5.4 2-2 4.8-2.7 7.7-2.7 3.1 0 6.6.4 9.2 1.3l-.8 3.4c-1.9-.3-5.4-.6-8-.6-2.5 0-5.9.4-5.9 3.4 0 1.8.4 2.7 2.4 3.4l8.1 2.8c2.2.8 3.2 1.8 4 3 .9 1.4 1.3 2.7 1.3 4.3 0 2.9-.9 4.2-2.9 5.8-2.3 1.8-5.4 2.2-8.7 2.2-2.8 0-6.7-.4-9.3-1.3l1-3.4zm38.9-23.9h10.5c4.7 0 7.4 0 10.4 3.1 2.7 2.7 2.9 4.9 2.9 11.1 0 6.1-.1 8.1-3 11-2.9 2.9-5.7 3.1-10.4 3.1h-10.5V2.5zm4.6 24.4h5.8c7.4 0 8.6-2 8.6-10.5 0-8.1-.7-10.1-8.6-10.1h-5.8v20.6zm32.1-24.4h3.4c1.7 0 2.3.2 3.4 1.1 1.2 1 1.5 1.2 2.1 3.1l8.5 24h-5l-2.2-6.7h-13l-2.3 6.7h-4.6l9.7-28.2zm-1.6 17.6h10.5l-4.7-14.2h-1l-4.8 14.2zm23.1-17.6h4.7v28.2h-4.7zm11.5 0h12.9c3.8 0 5.5.2 7.5 2.3 1.6 1.6 1.8 2.4 1.8 6.4 0 4.4-.6 5.4-2 6.8-1 .9-1.8 1.6-3 1.9l5.4 10.9h-5.2l-4.5-10.5h-8.2v10.5h-4.7V2.5zm4.6 13.8h7.3c4.5 0 5.6-.2 5.6-5 0-4.7-.6-5-5.2-5h-7.7v10zM318 2.5l6.6 13.8h1.8l6.4-13.8h5.2l-7.2 14.8c-.6 1.3-.9 1.6-1.8 2.3-.5.4-.8.6-1.2.7v10.5h-4.6V20.3c-.4-.2-.7-.4-1.2-.8-.9-.7-1.2-1-1.8-2.3l-7.5-14.8h5.3zm51.3 15.7c-.8.1-3.4.3-7.1.3h-3.9v12.2h-4.7V2.5h18.6v3.8h-14v8.4h11.1v3.5zm11.2-15.7h3.4c1.7 0 2.3.2 3.4 1.1 1.2 1 1.5 1.2 2.1 3.1l8.5 24h-5l-2.2-6.7h-13l-2.3 6.7h-4.6l9.7-28.2zm-1.6 17.6h10.5l-4.7-14.2h-1l-4.8 14.2zM402 2.5h12.9c3.8 0 5.5.2 7.5 2.3 1.6 1.6 1.8 2.4 1.8 6.4 0 4.4-.6 5.4-2 6.8-1 .9-1.8 1.6-3 1.9l5.4 10.9h-5.2l-4.5-10.5h-8.2v10.5H402V2.5zm4.7 13.8h7.3c4.5 0 5.6-.2 5.6-5 0-4.7-.6-5-5.2-5h-7.7v10zm44-10.4c.5-1.3.8-1.7 1.9-2.5 1-.7 1.4-.9 2.8-.9h4v28.2h-4.6V7.3h-.4L447 25.9h-4.9L435 7.3h-.4v23.4H430V2.5h4.3c1.4 0 1.8.2 2.8.9 1.1.8 1.4 1.2 1.9 2.5l5.6 14.6h.4l5.7-14.6zM483 17.8c-.8.1-3.4.3-7.1.3H471v6.6c0 1.9.5 2.3 2.1 2.3H486v3.3c-.8.1-3.4.3-7.1.3H471c-1.4 0-2-.3-3.2-1.5-1.1-1.1-1.5-1.7-1.5-3.2V2.5H486v3.8h-15v8h12v3.5zm8.4-15.3h12.9c3.8 0 5.5.2 7.5 2.3 1.6 1.6 1.8 2.4 1.8 6.4 0 4.4-.6 5.4-2 6.8-1 .9-1.8 1.6-3 1.9l5.4 10.9h-5.2l-4.5-10.5H496v10.5h-4.7V2.5zm4.6 13.8h7.3c4.5 0 5.6-.2 5.6-5 0-4.7-.6-5-5.2-5H496v10zm22.9 10.1c1.8.3 5.7.6 8.1.6 4.3 0 7.2-.3 7.2-3.5 0-1.8-.2-2.6-2.1-3.3l-8.2-2.9c-2.4-.9-2.9-1.4-4.1-2.9-1-1.3-1.4-2.8-1.4-4.2 0-2.8.7-3.7 2.4-5.4 2-2 4.8-2.7 7.7-2.7 3.1 0 6.6.4 9.2 1.3l-.7 3.4c-1.9-.3-5.4-.6-8-.6-2.5 0-5.9.4-5.9 3.4 0 1.8.4 2.7 2.4 3.4l8.1 2.8c2.2.8 3.2 1.8 4 3 .9 1.4 1.3 2.7 1.3 4.3 0 2.9-.9 4.2-2.9 5.8-2.3 1.8-5.4 2.2-8.7 2.2-2.8 0-6.7-.4-9.3-1.3l.9-3.4z" />
    </g>
  </Box>
);

export default SvgFwcLogo;
